import React, { use } from "react";
import { useEffect, useState } from "react";
import "./Privacy.css"; // Assuming you have a CSS file for styling

const Privacy = () => {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch("privacy-policy.md")
      .then((res) => res.text())
      .then(setMarkdown);
  }, []);

  return (
    <div className="privacy-policy-container">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <span
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            transform: "scale(2)",
          }}
        >
          <svg
            width="110"
            height="56"
            viewBox="0 0 219 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="logo-svg"
          >
            <path
              d="M41.586 34.1388C41.586 31.468 41.6223 29.2907 41.5787 27.1207C41.5424 25.4079 40.4248 24.0363 38.9805 23.8838C37.9935 23.775 36.9992 23.7097 36.0049 23.7024C34.5316 23.6806 33.7551 24.2395 33.2906 25.6547C32.935 26.7361 32.6592 27.8465 32.3399 28.9424C31.7375 31.0253 31.1424 33.1155 30.5255 35.1984C30.3223 35.8806 29.8868 36.3814 29.1175 36.3959C28.3119 36.4177 27.8184 35.9532 27.5716 35.2202C27.4265 34.8065 27.3031 34.3783 27.1943 33.9501C26.5048 31.3156 25.8153 28.6811 25.1331 26.0466C24.6251 24.0871 23.8703 23.4774 21.8817 23.4339C21.2576 23.4194 20.6262 23.4121 20.002 23.4193C18.1005 23.4339 17.0409 24.2249 16.6055 26.0756C15.9451 28.8698 15.1032 31.6132 14.3194 34.3711C14.0363 35.3726 13.7896 36.5556 12.4832 36.512C11.1841 36.4685 11.0172 35.2492 10.7486 34.2622C10.0011 31.4535 9.26811 28.6376 8.52058 25.8361C8.09238 24.2395 7.34486 23.4992 5.87157 23.5137C3.86123 23.5355 1.53156 22.7662 0.392128 25.3862C0.0727961 26.1119 0.0147326 26.874 0.0147326 27.6578C0.0147326 31.3374 0.014735 35.017 0.000219919 38.6966C-0.0142952 41.5996 0.689686 44.3212 2.11942 46.825C6.52475 54.5253 14.8637 55.3164 20.0528 50.6498C20.7641 50.0111 21.2648 50.149 21.9398 50.7296C25.6629 53.9012 30.7214 54.3439 34.7929 51.8546C38.516 49.5757 40.4901 46.1066 41.3174 41.9189C41.8618 39.1828 41.4553 36.4104 41.586 34.1606V34.1388Z"
              fill="#FEC34E"
            />
            <path
              d="M149.652 34.3261C149.666 28.041 149.013 22.4672 149.187 16.8716C149.224 15.783 148.781 14.8613 147.91 14.1863C146.923 13.417 145.813 13.2646 144.688 13.7654C143.301 14.3895 142.692 15.587 142.648 17.0458C142.576 19.4335 142.568 21.8213 142.402 24.209C142.278 25.8855 142.278 25.9363 140.812 25.1816C136.741 23.1059 132.502 22.6849 128.184 24.1655C116.681 28.1281 113.4 42.4691 122.08 50.9605C126.805 55.5763 132.502 56.8101 138.693 54.6401C144.535 52.5934 148.026 48.2897 149.195 42.2006C149.739 39.3701 149.717 36.4961 149.652 34.3188V34.3261Z"
              fill="#FEC34E"
            />
            <path
              d="M81.7929 44.7769C81.7929 47.0412 81.7711 49.0951 81.7929 51.1563C81.8292 53.7763 83.3678 55.3149 86.0022 55.402C87.0328 55.4382 88.0634 55.4382 89.094 55.4237C90.8358 55.402 91.7212 54.7923 92.3381 53.1303C92.7445 52.0272 93.0784 50.895 93.4485 49.7773C94.1888 47.542 94.9218 45.3067 95.6911 43.0858C95.9814 42.2512 96.562 41.7505 97.4982 41.7142C98.4852 41.6779 99.0949 42.1786 99.4432 43.0423C99.5811 43.3834 99.6827 43.739 99.7843 44.0874C100.699 47.1138 101.599 50.1475 102.535 53.1666C103.108 55.0101 103.986 55.6415 105.939 55.6632C106.933 55.6778 107.927 55.6777 108.922 55.6777C111.832 55.6777 113.167 54.3496 113.204 51.4393C113.24 48.8266 113.218 46.2211 113.327 43.6084C113.472 40.1538 113.429 36.7137 112.137 33.3897C109.64 26.945 102.557 22.4525 95.9814 23.2654C88.5134 24.1871 82.8089 29.8625 81.9671 37.1419C81.6695 39.7473 81.9235 42.3601 81.7856 44.7623L81.7929 44.7769Z"
              fill="#FEC34E"
            />
            <path
              d="M46.3506 38.9602C46.1837 47.6039 53.1074 54.7889 61.9834 54.9051C70.6561 55.0212 77.7613 48.3733 77.9935 39.3085C78.2185 30.7083 71.0698 23.4217 62.3825 23.2402C53.717 23.0588 46.5175 30.1204 46.3506 38.9602Z"
              fill="#FEC34E"
            />
            <path
              d="M174.949 46.5932C177.344 46.7021 179.557 46.2884 181.72 45.686C183.353 45.2361 184.695 44.3506 185.08 42.5362C185.646 39.8945 185.559 37.26 184.739 34.6835C181.909 25.8365 173.011 21.286 164.149 24.1237C155.985 26.7365 151.238 36.3092 154.148 44.3797C156.522 50.9695 161.355 54.5185 168.199 55.3386C170.834 55.6579 173.417 55.1136 175.732 53.6984C176.451 53.2629 177.3 52.7114 176.901 51.7025C176.516 50.7155 175.551 50.9913 174.774 51.122C173.062 51.4123 171.349 51.5937 169.607 51.4921C167.604 51.376 165.746 50.8171 164.28 49.3874C162.879 48.023 163.358 46.2884 165.245 45.7731C166.102 45.5409 166.972 45.5046 167.872 45.6207C170.275 45.9328 172.597 46.8182 174.949 46.5932Z"
              fill="#FEC34E"
            />
            <path
              d="M198.92 45.0974C198.92 45.0974 198.927 45.0974 198.934 45.0974C198.934 43.1887 198.92 41.2727 198.934 39.3639C198.956 36.8746 200.85 35.3722 203.289 35.8948C204.537 36.1633 205.633 36.7657 206.634 37.5277C207.745 38.3769 208.986 38.9139 210.343 39.1462C212.375 39.4873 214.378 39.5381 216.105 38.0938C219.495 35.2489 219.458 27.4542 214.545 25.364C209.516 23.2303 204.704 23.8472 200.117 26.6486C199.028 27.3091 199.079 27.3889 198.6 26.1551C197.889 24.3117 196.249 23.2884 194.253 23.4335C192.395 23.5714 190.914 24.8996 190.552 26.8156C190.414 27.5341 190.37 28.2743 190.327 29.0073C189.906 35.4956 189.477 41.9839 189.078 48.4794C188.991 49.9019 188.759 51.3534 189.282 52.7396C190.094 54.8734 192.359 56.2741 194.413 55.9548C197.062 55.5483 198.803 53.7484 198.898 51.1575C198.978 49.1399 198.912 47.115 198.912 45.0901L198.92 45.0974Z"
              fill="#FEC34E"
            />
            <path
              d="M0.904192 9.97677H0.875161C0.875161 11.0436 0.853389 12.1105 0.875161 13.1774C0.904192 14.4474 1.38319 15.0353 2.45731 15.2022C4.25718 15.478 4.98294 15.1805 5.42565 13.8886C5.86836 12.604 6.23849 11.2904 6.65943 9.99128C6.82635 9.46147 6.99328 8.87363 7.69726 8.87363C8.45204 8.87363 8.64074 9.48327 8.8004 10.0566C9.14151 11.2251 9.46084 12.3936 9.77292 13.5693C10.1648 15.0353 10.6583 15.4345 12.1897 15.4562C13.7718 15.478 14.3089 15.0789 14.7298 13.5838C15.0564 12.4153 15.383 11.2468 15.7459 10.0856C15.9273 9.49777 16.0725 8.77201 16.8853 8.80105C17.6183 8.83008 17.7707 9.476 17.9377 10.0494C18.286 11.2541 18.6126 12.4589 18.9682 13.6564C19.4182 15.1659 21.5301 15.9498 22.8728 15.1152C23.272 14.8684 23.584 14.5055 23.584 14.0555C23.584 11.1598 24.2517 8.24222 23.4316 5.38273C21.9874 0.331453 16.6386 -1.46119 12.988 1.28218C12.3566 1.75392 11.8486 1.57249 11.2825 1.19509C6.59411 -1.9039 1.30336 1.68136 0.904192 6.66731C0.817102 7.76321 0.88968 8.87362 0.88968 9.97677H0.904192Z"
              fill="#FEC34E"
            />
            <path
              d="M44.21 4.60593C44.1955 0.72312 43.5278 0.0917165 40.2764 0.280414C39.2386 0.338474 38.5491 0.759413 38.1717 1.7537C37.6928 3.03104 37.1702 4.28658 36.6622 5.5494C36.4299 6.13727 36.0671 6.58725 35.3776 6.57999C34.6736 6.57273 34.3615 6.09374 34.1438 5.49862C33.6648 4.185 33.2076 2.86411 32.6778 1.57226C31.9811 -0.118754 28.3087 -0.539712 27.1693 0.919062C26.8572 1.31823 26.7847 1.78273 26.7774 2.26898C26.7629 3.1907 26.7774 4.1124 26.7556 5.02686C26.6685 7.94441 28.1346 9.96927 30.4715 11.4934C32.1698 12.5965 34.1003 12.8651 36.0671 12.9594C36.4807 12.9812 36.9235 12.9957 37.0613 13.4747C37.2138 14.0045 36.8218 14.2803 36.4299 14.5198C35.8203 14.8972 35.1526 15.0423 34.4341 15.0786C32.6488 15.1584 31.0231 14.6649 29.4772 13.794C28.9111 13.4747 28.3233 13.4384 27.9023 14.0408C27.5032 14.6141 27.7644 15.0931 28.2362 15.4778C31.8214 18.3591 38.8104 18.5986 41.9965 13.3223C43.7165 10.4701 44.0649 7.31301 44.21 4.61319V4.60593Z"
              fill="#FEC34E"
            />
          </svg>
        </span>
      </div>
      <div>
        <img
          src="https://cdn.shopify.com/s/files/1/0670/8425/5420/files/Adobe_Express_-_file.jpg?v=1746009330"
          alt="MyWonder Banner"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>

      <div>
        <h2>MyWonder Privacy Policy - Simplified for Parents</h2>

        <p>
          <strong>Effective Date:</strong> 19 June 2025
          <br />
          <strong>Last Updated:</strong> 19 June 2025
        </p>
      </div>

      <div>
        <h2>Principles We Follow</h2>
        <p>We care deeply about your family's safety. Here's what guides us:</p>
        <ul>
          <li>
            <strong>Clear Language:</strong> We avoid legal jargon.
          </li>
          <li>
            <strong>Parental Control:</strong> You decide what data to share and
            when.
          </li>
          <li>
            <strong>Safety First:</strong> We protect all your and your child's
            information.
          </li>
        </ul>
      </div>

      <div>
        <h2>What We Collect and Why</h2>
        <table
          style={{ border: "1px solid black", borderCollapse: "collapse" }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "8px" }}>Who</th>
              <th style={{ border: "1px solid black", padding: "8px" }}>
                What Info
              </th>
              <th style={{ border: "1px solid black", padding: "8px" }}>
                Why We Collect It
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Parent
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Name, Phone
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                To help you create an account and manage the Device
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Child
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                First name/nickname, age, gender, data from voice chat
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                To make the experience more personal and fun
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                App/Website
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Device type, usage, errors, location (if allowed)
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                To make things work better and safer
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h2>Children's Data (Under Age 13)</h2>
        <ul>
          <li>No data from children is collected without your permission.</li>
          <li>
            Voice recordings are turned into text so the toy can talk back. We{" "}
            <strong>delete the voice</strong> immediately and keep the{" "}
            <strong>text for 90 days</strong>.
          </li>
          <li>
            You can <strong>see or delete this data</strong> anytime from the
            Parent App.
          </li>
        </ul>
      </div>

      <div>
        <h2>How We Use This Info</h2>
        <table
          style={{ border: "1px solid black", borderCollapse: "collapse" }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "8px" }}>Use</th>
              <th style={{ border: "1px solid black", padding: "8px" }}>
                Explanation
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Operate MyWonder
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                To personalize how it speaks to your child
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Help you
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                To send updates, help with support, or improve our service
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Safety
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                To make sure everything works well and protect against issues
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h2>Who We Share Data With</h2>
        <p>
          We <strong>never sell</strong> your data. We may share it only with:
        </p>
        <ul>
          <li>
            Trusted service providers (e.g. for voice-to-text, cloud storage)
          </li>
          <li>Law enforcement (if legally required)</li>
          <li>
            Another company if MyWonder is ever sold or merged (you'll be
            notified)
          </li>
        </ul>
      </div>

      <div>
        <h2>Your Choices</h2>
        <p>You are in control of your data. Here's what you can do:</p>
        <table
          style={{ border: "1px solid black", borderCollapse: "collapse" }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "8px" }}>
                Option
              </th>
              <th style={{ border: "1px solid black", padding: "8px" }}>
                What You Can Do
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Voice Data
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Turn off microphone to prevent recording. Delete all data
                anytime from Parent App.
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Emails
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Choose to get updates or unsubscribe
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Location
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Allow or block location sharing
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Cookies
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Accept or reject cookies in your settings
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h2>How Long We Keep Your Data</h2>
        <table
          style={{ border: "1px solid black", borderCollapse: "collapse" }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "8px" }}>
                Type of Data
              </th>
              <th style={{ border: "1px solid black", padding: "8px" }}>
                How Long We Keep It
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Voice recordings
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Deleted immediately after converting to text
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Conversation text
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Stored for 90 days or until you delete it
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Parent account info
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                As long as your account is active
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Device/app usage
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Short-term logs to help us improve things
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h2>How We Protect Your Info</h2>
        <ul>
          <li>
            We use encryption (a kind of digital lock) to protect your
            information
          </li>
          <li>We store data on secure servers with limited access</li>
          <li>Only trained and trusted staff can view sensitive information</li>
          <li>
            We use cookies and other safe tools to help the app and website work
            smoothly
          </li>
        </ul>
      </div>

      <div>
        <h2>Children Using MyWonder</h2>
        <ul>
          <li>
            Children only use the MyWonder device. The app and website are for
            parents/adults only.
          </li>
          <li>
            We are committed to following COPPA and other child safety laws.
          </li>
        </ul>
      </div>

      <div>
        <h2>Other Info We'd Like You to Know</h2>
        <ul>
          <li>
            <strong>Cookies and Tracking:</strong>
            <br />
            We use small files called cookies to improve your experience.
            Cookies help remember preferences, ensure smooth operation, and
            analyze usage. You can block or delete cookies in your settings.
          </li>
          <li>
            <strong>Third-party Links:</strong>
            <br />
            Occasionally, we link to other websites (e.g., helpful resources or
            videos). These have their own privacy policies. Please review them
            before use.
          </li>
          <li>
            <strong>Changes to This Policy:</strong>
            <br />
            We may update this Privacy Policy from time to time. For major
            changes, we'll notify you through the app or by email. The latest
            version is always available at the top of this page.
          </li>
        </ul>
      </div>

      <div>
        <h2>Contact Us</h2>
        <p>If you have questions or need help:</p>
        <ul>
          <li>
            Email: <a href="mailto:info@mywonder.in">info@mywonder.in</a>
          </li>
          <li>WhatsApp: +91 9008404341</li>
        </ul>
      </div>
    </div>
  );
};

export default Privacy;
